import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Is this suitable for beginner coaches or only experienced ones?',
  a: 'Functional & Cross Ready was designed to work for coaches at every level. Whether you are just starting out or have years of experience, the six volumes take you from foundational principles all the way through advanced programming. Each volume builds on the previous one, so you always have the right content for where you are right now.'
}, {
  q: 'Do I receive physical materials?',
  a: 'No. Functional & Cross Ready is a 100% digital product. Upon purchase you receive instant access to all six volumes and five bonuses in PDF format. No shipping, no waiting — available immediately after checkout on any device.'
}, {
  q: 'Can I read it on my phone or tablet?',
  a: 'Absolutely. All materials are delivered in PDF format, fully compatible with any smartphone, tablet, laptop or desktop computer. You can read them at home, at the gym or anywhere else you coach.'
}, {
  q: 'Is this a theory course or a certification program?',
  a: 'Neither. Functional & Cross Ready is a practical, operational coaching system — not a theory textbook and not a certification. Every volume is built around tools, templates, protocols and ready-to-use content you can apply immediately in your sessions. No exams, no deadlines, no expiration date.'
}, {
  q: 'Will this actually help me prepare sessions faster?',
  a: 'Yes — that is exactly what it was built for. Instead of spending hours searching for exercises, building progressions or planning your week from scratch, you will have a complete system ready to consult at any moment. Most coaches report saving several hours of preparation time every single week.'
}, {
  q: 'What is the 7-day guarantee?',
  a: 'If for any reason you are not completely satisfied with Functional & Cross Ready within 7 days of purchase, contact us and we will issue a full refund — no questions asked. We are confident in what this system delivers, and we want you to feel zero risk in trying it.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-12 md:py-24 px-4 bg-[#050505] border-t border-zinc-800/50" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <div className="text-center mb-10 md:mb-16" data-id="element-49">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-50">
            FREQUENTLY ASKED{' '}
            <span className="text-brand-orange" data-id="element-51">QUESTIONS</span>
          </h2>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-52">
          {faqs.map((faq, idx) => <div key={idx} className={`border rounded-xl overflow-hidden transition-colors ${openIdx === idx ? 'bg-zinc-900 border-brand-blue/30' : 'bg-zinc-900/30 border-zinc-800 hover:border-zinc-700'}`} data-id="element-53">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full flex items-center justify-between p-4 md:p-6 text-left" data-id="element-54">
                <span className="text-base md:text-lg font-bold text-white pr-4 md:pr-8" data-id="element-55">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 md:w-6 md:h-6 text-brand-blue shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-56" />
              </button>
              <AnimatePresence data-id="element-57">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-58">
                    <div className="p-4 md:p-6 pt-0 text-sm md:text-base text-zinc-400 leading-relaxed" data-id="element-59">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}